import { ClipboardList, Gauge, TrendingDown } from 'lucide-react';

// Photo du panneau de gauche, hébergée sur Cloudinary (f_auto/q_auto : format et poids adaptés au
// navigateur). Original : Wikimedia Commons, Saiphani02, CC BY-SA 4.0 — crédit en pied de page.
const HERO_BASE = 'https://res.cloudinary.com/dc1felxem/image/upload';
const HERO_ID = 'v1792744572/walter_image/brand/login-station-eau.jpg';
const heroUrl = (width) => `${HERO_BASE}/f_auto,q_auto,c_limit,w_${width}/${HERO_ID}`;
const HERO_CREDIT_URL = 'https://commons.wikimedia.org/wiki/File:Krishnapuram_Tatipudi_Water_Works_aerial_view_top-down_view_03.jpg';

const FEATURES = [
    { icon: ClipboardList, text: 'Inventaire des points d\'eau sur le terrain, même hors connexion' },
    { icon: Gauge, text: 'Consommations estimées par usage et calées sur les relevés réels' },
    { icon: TrendingDown, text: 'Plan d\'actions chiffré pour réduire la facture d\'eau' },
];

// Mise en page des écrans d'authentification (connexion, invitation, réinitialisation, attente
// client) : photo et promesse à gauche, formulaire à droite ; sur mobile, la photo devient un
// bandeau au-dessus du formulaire.
export default function AuthCard({ title, subtitle, children }) {
    return (
        <div className="auth-split">
            <aside className="auth-hero">
                <img
                    className="auth-hero-img"
                    src={heroUrl(1400)}
                    srcSet={`${heroUrl(800)} 800w, ${heroUrl(1400)} 1400w, ${heroUrl(2000)} 2000w`}
                    sizes="(max-width: 899px) 100vw, 55vw"
                    alt=""
                />
                <div className="auth-hero-overlay" />
                <div className="auth-hero-content">
                    <img className="auth-hero-logo" src="/brand/walter-logo-dark.svg" alt="Walter by Hydros" />
                    <div className="auth-hero-pitch">
                        <h2 className="auth-hero-title">L'outil d'audit eau de vos bâtiments</h2>
                        <ul className="auth-hero-features">
                            {FEATURES.map(({ icon: Icon, text }) => (
                                <li key={text}>
                                    <span className="auth-hero-feature-icon"><Icon size={16} strokeWidth={2.25} /></span>
                                    {text}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </aside>

            <main className="auth-panel">
                <div className="auth-panel-main">
                    <div className="auth-card">
                        <h1 className="auth-title">{title}</h1>
                        {subtitle && <p className="auth-subtitle">{subtitle}</p>}
                        {children}
                    </div>
                </div>
                <footer className="auth-panel-footer">
                    <span>© {new Date().getFullYear()} Hydros Consulting</span>
                    <a href={HERO_CREDIT_URL} target="_blank" rel="noopener noreferrer">Photo : Saiphani02, CC BY-SA 4.0</a>
                </footer>
            </main>
        </div>
    );
}
